<template>
  <form @submit.prevent="onSearch" v-if="coachDropdown && coachDropdown.length">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.lastName"
            :options="unemployedDropdown"
            :is-clear="true"
            :showMinCharsMessage="true"
            placeholder="Nachname des Kunden"
            :no-options-text="'Type to search...'"
            @dropdown-fetch="(search) => handleDropdownSearch(search, 'lastName')"
            @update:modelValue="(val) => onSelectValue(val, 'lastName')"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
          <SelectVue
              v-model="filters.coachId"
              :options="coachDropdown"
              :is-clear="true"
              :placeholder="$t('general.coach')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :placeholder="$t('general.start_date')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :placeholder="$t('general.end_date')"/>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters['officeIds[]']"
              :options="officeDropdown"
              :is-clear="true"
              :is-multi="true"
              :placeholder="$t('placeholder.office_name')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <div v-if="classificationDropdown && classificationDropdown.length">
          <SelectVue
              v-model="filters.classification"
              :options="classificationDropdown"
              :is-clear="true"
              :placeholder="$t('general.classification')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="statusDropdown && statusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="statusDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"/>
        </div>
      </div>

      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  unemployedDropdown: {
    type: Array,
    require: true,
  },
  classificationDropdown: {
    type: Array,
    required: true,
  },
  coachDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search', 'dropdown-fetch', 'clear-dropdown']);
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search, type) {
  emit('dropdown-fetch', search, type);
}

function onSelectValue(value) {
  if (!value) {
    emit('clear-dropdown');
  }
}

</script>

<style scoped>
</style>
